import FulfillmentQueue from './FulfillmentQueue';
export default function FulfillmentDiscrepancies() {
  return (
    <FulfillmentQueue
      title="Discrepancies"
      statusFilter="discrepancy"
      emptyMessage="No fulfillment discrepancies"
      extraColumns={[
        {
          headerName: 'Discrepancy Notes',
          field: 'discrepancy_notes',
          width: 160,
          cellStyle: { display: 'flex', alignItems: 'center', color: 'var(--ink-secondary)' },
        },
      ]}
    />
  );
}
